import { render, staticRenderFns } from "./ViewerDocx.vue?vue&type=template&id=7e29d1d4&scoped=true"
import script from "./ViewerDocx.vue?vue&type=script&lang=js"
export * from "./ViewerDocx.vue?vue&type=script&lang=js"
import style0 from "./ViewerDocx.vue?vue&type=style&index=0&id=7e29d1d4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e29d1d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e29d1d4')) {
      api.createRecord('7e29d1d4', component.options)
    } else {
      api.reload('7e29d1d4', component.options)
    }
    module.hot.accept("./ViewerDocx.vue?vue&type=template&id=7e29d1d4&scoped=true", function () {
      api.rerender('7e29d1d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DocumentViewer/ViewerDocx.vue"
export default component.exports